import reportsApi from '../../../../services/reports.api';
import MicroLifeReportFilter from '../../../filtros/MicroLifeReportFilter/MicroLifeReportFilter.vue';
import functions from '../../../../utils/functions';

export default {
  name: 'MicroLife',
  components: {
    MicroLifeReportFilter,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async exportReport(filters) {
      this.$vs.loading();
      try {
        const buffer = await reportsApi.exportMicroLifeReport(filters);
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `micro-life-report-${now}.xlsx`;
        await functions.downloadFromBuffer(window, buffer, fileName);
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Erro ao fazer download do arquivo.`,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
